import { Type, ValidationErrors } from '@/entities/validation';

type ApiErrorMessage = {
  field: string;
  type: string;
  parameters?: Array<string|number>;
};

type ErrorTypeMapping = { [type: string]: Type };

const typeMapping: ErrorTypeMapping = {
  'validation.unique': 'unique',
  'validation.exists': 'exists',
  'validation.in': 'in',
  'validation.required': 'required',
  'validation.mimes': 'mime',
  'validation.max.file': 'maxFile',
  'validation.multipleValuesNotAllowed': 'multipleValuesNotAllowed',
  'validation.invalidOptionValue': 'invalidOptionValue',
  'validation.duplicateId': 'duplicateId',
  'validation.excel.maxRows': 'excelMaxRows',
  'validation.notFound': 'notFound',
  'validation.typeMismatch': 'typeMismatch',
};

const mapType = (type: string): Type => typeMapping[type] || 'unknown';

export const transform = (errors: ApiErrorMessage[]): ValidationErrors => errors.map(error => ({
  field: error.field,
  type: mapType(error.type),
  parameters: (error.parameters ?? []).map(parameter => String(parameter)),
}));
